var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.hasSideEffectLoading,"width":"30%","close-on-click-modal":false,"before-close":_vm.handleDialogClose},on:{"update:visible":function($event){_vm.hasSideEffectLoading=$event}}},[_c('div',{staticClass:"loading-content"},[_c('el-spinner'),_c('p',[_vm._v("Loading, please wait...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }